(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dogheroes--dogs--form"] && !Shopify.designMode) return;
  try {
    // Track form dirty state and manage loading state
  const form = document.getElementById('dog-form')
  const submitBtn = document.getElementById('dog-form-preview-button')
  const sticky = submitBtn?.closest('.sticky')
  const previewDialog = document.getElementById('dog-form-preview-dialog')
  const previewContent = document.getElementById('dog-form-preview-content')
  const previewLoading = previewContent?.querySelector('.dog-form-preview-loading')
  const previewError = previewContent?.querySelector('.dog-form-preview-error')
  const previewBody = previewContent?.querySelector('.dog-form-preview-body')
  const previewConfirmBtn = previewDialog?.querySelector('[data-dialog-confirm]')

  // Fields whose changes don't impact the meal plan calculation, so we can
  // skip the preview dialog and submit the form directly.
  const SAFE_FIELDS = new Set([
    'dog[name]',
    'dog[hunger]',
    'dog[allergies]',
    'dog[allergies][]',
    'dog[diseases]',
    'dog[diseases][]',
    'dog[has_diseases]',
    // Derived field, updated client-side from the other inputs; safe by definition.
    'dog[daily_calories]',
  ])
  // Age fields are safe only when the dog is older than 15 months in both the
  // initial and the current state (puppy calorie formulas differ).
  const AGE_FIELDS = new Set(['dog[birthday]', 'dog[birthday_type]'])
  const PUPPY_MONTHS_THRESHOLD = 15

  if (form && submitBtn) {
    const currentEntries = () => Array.from(new FormData(form).entries()).map(([name, value]) => [name, String(value)])

    // Serialize as normalized FormData so radio groups and multi-value fields compare correctly.
    const serializeEntries = (entries) =>
      JSON.stringify(
        [...entries].sort((a, b) => {
          if (a[0] !== b[0]) return a[0].localeCompare(b[0])
          return a[1].localeCompare(b[1])
        })
      )

    let initialEntries = []
    let initialState = ''

    // Check if form state differs from initial state
    const updateDirtyState = () => {
      const hasChanges = serializeEntries(currentEntries()) !== initialState
      submitBtn.disabled = !hasChanges
    }

    // Some controls are hydrated after initial render; snapshot after the form settles.
    const captureInitialState = () => {
      initialEntries = currentEntries()
      initialState = serializeEntries(initialEntries)
      updateDirtyState()
    }

    // Group entries by field name so multi-value fields (checkboxes) compare correctly.
    const groupEntries = (entries) => {
      const map = new Map()
      for (const [name, value] of entries) {
        if (!map.has(name)) map.set(name, [])
        map.get(name).push(value)
      }
      for (const values of map.values()) values.sort()
      return map
    }

    const changedFieldNames = (oldEntries, newEntries) => {
      const oldMap = groupEntries(oldEntries)
      const newMap = groupEntries(newEntries)
      const names = new Set([...oldMap.keys(), ...newMap.keys()])
      const changed = []
      for (const name of names) {
        const a = (oldMap.get(name) || []).join('|')
        const b = (newMap.get(name) || []).join('|')
        if (a !== b) changed.push(name)
      }
      return changed
    }

    const buildDogFromEntries = (entries) => {
      const attrs = {}
      for (const [name, value] of entries) {
        const match = name.match(/^dog\[([^\]]+)\]/)
        if (!match) continue
        const key = match[1]
        if (key in attrs) {
          attrs[key] = [].concat(attrs[key], value)
        } else {
          attrs[key] = value
        }
      }
      return new DogHeroes.Dog(attrs)
    }

    // Returns true when every changed field can skip the meal plan preview.
    const canSkipPreview = () => {
      const changed = changedFieldNames(initialEntries, currentEntries())
      if (changed.length === 0) return false
      const allSafe = changed.every((name) => SAFE_FIELDS.has(name) || AGE_FIELDS.has(name))
      if (!allSafe) return false
      const ageChanged = changed.some((name) => AGE_FIELDS.has(name))
      if (ageChanged) {
        const oldMonths = buildDogFromEntries(initialEntries).age?.inMonths ?? 0
        const newMonths = buildDogFromEntries(currentEntries()).age?.inMonths ?? 0
        if (oldMonths <= PUPPY_MONTHS_THRESHOLD || newMonths <= PUPPY_MONTHS_THRESHOLD) {
          return false
        }
      }
      return true
    }

    // Recompute the derived daily_calories hidden field from the current form
    // state so it is always in sync when the form is submitted.
    const dailyCaloriesInput = document.getElementById('dog-daily-calories')
    const updateDailyCalories = () => {
      if (!dailyCaloriesInput) return
      const dog = buildDogFromEntries(currentEntries())
      const value = Math.round(dog.dailyCalories() || 0)
      dailyCaloriesInput.value = String(value)
    }

    // Update dirty state on any input or change
    form.addEventListener('input', () => {
      updateDailyCalories()
      updateDirtyState()
    })
    form.addEventListener('change', () => {
      updateDailyCalories()
      updateDirtyState()
    })

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        updateDailyCalories()
        captureInitialState()
      })
    })

    // Toggle loading state on form submit (real submission triggered from the dialog confirm button).
    form.addEventListener('submit', () => {
      if (sticky) {
        sticky.setAttribute('data-loading', '')
      }
      submitBtn.disabled = true
      const cancelLink = sticky?.querySelector('.dh-button-secondary')
      if (cancelLink) cancelLink.style.pointerEvents = 'none'
    })

    // Fetch preview HTML when the user opens the dialog.
    if (previewDialog && previewContent && previewBody && previewLoading && previewError) {
      let currentRequestToken = 0

      const showLoading = () => {
        previewLoading.hidden = false
        previewError.hidden = true
        previewBody.hidden = true
        previewBody.innerHTML = ''
        if (previewConfirmBtn) previewConfirmBtn.disabled = true
      }

      const showError = () => {
        previewLoading.hidden = true
        previewError.hidden = false
        previewBody.hidden = true
        if (previewConfirmBtn) previewConfirmBtn.disabled = true
      }

      const showBody = (html) => {
        previewBody.innerHTML = html
        previewLoading.hidden = true
        previewError.hidden = true
        previewBody.hidden = false
        if (previewConfirmBtn) previewConfirmBtn.disabled = false
      }

      submitBtn.addEventListener('click', async (event) => {
        if (submitBtn.disabled) return

        // If only fields that don't impact the meal plan have changed, skip
        // the preview dialog entirely and submit the form directly.
        if (canSkipPreview()) {
          event.preventDefault()
          event.stopImmediatePropagation()
          form.requestSubmit()
          return
        }

        const url = submitBtn.dataset.previewUrl
        if (!url) return

        const token = ++currentRequestToken
        showLoading()

        // Build a Dog instance from the form fields so we can reuse the
        // existing client-side calorie calculation (see assets/dogheroes--dog.js
        // and the same approach used in snippets/dogheroes--quiz.liquid).
        // The server only needs the resulting daily_calories value to render
        // the new meal plan.
        const dog = buildDogFromEntries(currentEntries())
        const dailyCalories = Math.round(dog.dailyCalories() || 0)

        const requestUrl = new URL(url, window.location.origin)
        requestUrl.searchParams.set('daily_calories', String(dailyCalories))

        try {
          const response = await fetch(requestUrl, {
            method: 'GET',
            headers: { Accept: 'text/html' },
            credentials: 'same-origin',
          })
          if (!response.ok) throw new Error(`Preview request failed: ${response.status}`)
          const html = await response.text()
          if (token !== currentRequestToken) return
          showBody(html)
        } catch (error) {
          if (token !== currentRequestToken) return
          console.error('Failed to load meal plan preview:', error)
          showError()
        }
      })
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--dogs--portions"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--dogs--portions',
    class extends Stimulus.Controller {
      static targets = [
        'card',
        'submit',
        'currentLabel',
        'newLabel',
        'currentGrams',
        'newGrams',
        'deltaGrams',
        'currentPrice',
        'newPrice',
        'deltaPrice',
      ]
      static values = {
        current: String,
        full: Object,
        half: Object,
      }

      connect() {
        this.syncCards()
        this.syncSubmit()
        this.renderDiff()
        this.boundPageshow = this.#stopSubmitting.bind(this)
        window.addEventListener('pageshow', this.boundPageshow)
      }

      disconnect() {
        window.removeEventListener('pageshow', this.boundPageshow)
      }

      select() {
        this.syncCards()
        this.syncSubmit()
        this.renderDiff()
      }

      startSubmitting() {
        this.element.dataset.loading = ''
        if (this.hasSubmitTarget) this.submitTarget.disabled = true
        for (const button of this.element.querySelectorAll('.dogheroes--portal--dialog button')) {
          button.disabled = true
        }
      }

      #stopSubmitting() {
        delete this.element.dataset.loading
        for (const button of this.element.querySelectorAll('.dogheroes--portal--dialog button')) {
          button.disabled = false
        }
        this.syncSubmit()
      }

      get selected() {
        const checked = this.cardTargets
          .map((card) => card.querySelector('input[type="radio"]'))
          .find((input) => input && input.checked)
        return checked ? checked.value : this.currentValue
      }

      syncCards() {
        const selected = this.selected
        for (const card of this.cardTargets) {
          card.classList.toggle('is-selected', card.dataset.portion === selected)
        }
      }

      syncSubmit() {
        if (!this.hasSubmitTarget) return
        this.submitTarget.disabled = this.selected === this.currentValue
      }

      renderDiff() {
        const labels = { full: 'Pasto completo', half: 'Metà porzione' }
        const current = this.currentValue
        const next = this.selected
        const currentData = this[`${current}Value`] || {}
        const nextData = this[`${next}Value`] || {}

        if (this.hasCurrentLabelTarget) this.currentLabelTarget.textContent = labels[current] || '—'
        if (this.hasNewLabelTarget) this.newLabelTarget.textContent = labels[next] || '—'

        const currentGrams = Math.round(currentData.daily_grams ?? 0)
        const nextGrams = Math.round(nextData.daily_grams ?? 0)
        if (this.hasCurrentGramsTarget) this.currentGramsTarget.textContent = `${currentGrams}g`
        if (this.hasNewGramsTarget) this.newGramsTarget.textContent = `${nextGrams}g`
        this.#renderDelta(this.deltaGramsTarget, nextGrams - currentGrams, 'g')

        if (this.hasCurrentPriceTarget) this.currentPriceTarget.textContent = this.#formatPrice(currentData.daily_price)
        if (this.hasNewPriceTarget) this.newPriceTarget.textContent = this.#formatPrice(nextData.daily_price)
        this.#renderDelta(
          this.deltaPriceTarget,
          (nextData.daily_price ?? 0) - (currentData.daily_price ?? 0),
          '',
          this.#formatPrice.bind(this)
        )
      }

      #renderDelta(node, value, suffix = '', formatter = null) {
        if (!node) return
        const rounded = Math.round(value * 100) / 100
        if (rounded === 0) {
          node.textContent = ''
          node.classList.remove('is-positive', 'is-negative')
          return
        }
        const sign = rounded > 0 ? '+' : '−'
        const abs = Math.abs(rounded)
        const formatted = formatter ? formatter(abs) : `${abs}${suffix}`
        node.textContent = `(${sign}${formatted})`
        node.classList.toggle('is-positive', rounded > 0)
        node.classList.toggle('is-negative', rounded < 0)
      }

      #formatPrice(value) {
        const amount = Number(value ?? 0)
        try {
          return new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
          }).format(amount)
        } catch {
          return `€${amount.toFixed(2)}`
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--dialog"] && !Shopify.designMode) return;
  try {
    // Toggle loading state on the dialog when its associated form is submitted.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target
      if (!(form instanceof HTMLFormElement) || !form.id) return
      const dialog = document.querySelector(`dialog.dogheroes--portal--dialog[data-form-id="${CSS.escape(form.id)}"]`)
      if (!dialog) return
      dialog.setAttribute('data-loading', '')
      const confirmBtn = dialog.querySelector('[data-dialog-confirm]')
      const cancelBtn = dialog.querySelector('[data-dialog-cancel]')
      if (confirmBtn) confirmBtn.disabled = true
      if (cancelBtn) cancelBtn.disabled = true
    },
    true
  )

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('dialog.dogheroes--portal--dialog[data-close-on-backdrop]')
    if (!dialog || event.target !== dialog) return
    if (dialog.hasAttribute('data-loading')) return
    const rect = dialog.getBoundingClientRect()
    const inDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    if (!inDialog) dialog.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--dog-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target
    if (input.type !== 'file' || !input.closest('.dogheroes--portal--dog-card__image-dialog')) return

    const dialog = input.closest('.dogheroes--portal--dog-card__image-dialog')
    const section = dialog.querySelector('.photo-section')
    const preview = dialog.querySelector('.preview')
    if (!preview || !section) return

    const file = input.files[0]
    if (file) {
      const url = URL.createObjectURL(file)
      preview.src = url
      section.classList.remove('hidden')
      preview.onload = () => URL.revokeObjectURL(url)
    } else {
      preview.src = ''
      section.classList.add('hidden')
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--subscription--dialog--cancellation-reason"] && !Shopify.designMode) return;
  try {
    // Nasconde il media se l'immagine del reason non carica (404, URL rotto, ecc.)
  document.addEventListener(
    'error',
    (event) => {
      const img = event.target
      if (!(img instanceof HTMLImageElement)) return
      if (!img.matches('img[data-reason-image]')) return
      const media = img.closest('[data-reason-media]')
      if (media) media.setAttribute('hidden', '')
    },
    true
  )

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest(
      'dialog.dogheroes--portal--subscription--dialog--cancellation-reason[data-close-on-backdrop]'
    )
    if (!dialog || event.target !== dialog) return
    if (dialog.hasAttribute('data-loading')) return
    const rect = dialog.getBoundingClientRect()
    const inDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    if (!inDialog) dialog.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--portal--subscription--dialog--pause-success"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const dialog = event.target.closest(
      'dialog.dogheroes--portal--subscription--dialog--pause-success[data-close-on-backdrop]'
    )
    if (!dialog || event.target !== dialog) return
    const rect = dialog.getBoundingClientRect()
    const inDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    if (!inDialog) dialog.close()
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz--steps--breed"] && !Shopify.designMode) return;
  try {
    const { Dog } = DogHeroes

  Stimulus.register(
    'breed-step',
    class extends Stimulus.Controller {
      connect() {
        this.element.addEventListener('keydown', (e) => this.handleSummaryKeydown(e), true)
      }

      handleSummaryKeydown(e) {
        // Enter key toggle for accessibility
        if (e.key === 'Enter' && e.target.tagName === 'SUMMARY') {
          e.preventDefault()
          e.stopPropagation()
          e.target.parentElement.toggleAttribute('open')
        }
      }
    }
  )

  Stimulus.register(
    'breed-fieldset',
    class extends Stimulus.Controller {
      connect() {
        this.setupListeners()
      }

      setupListeners() {
        const dogIndexDiv = this.element.querySelector('[data-dog-index]')
        const dogIndex = dogIndexDiv ? parseInt(dogIndexDiv.dataset.dogIndex) : null

        // Exit early if fieldset doesn't have a valid dog index
        if (dogIndex == null) return

        // Syncs to Dog Obj
        const primaryBreedInput = this.element.querySelector('input[name*="[breed]"]:not([name*="additional"])')
        if (primaryBreedInput) {
          primaryBreedInput.addEventListener('change', () => this.updateBreed(dogIndex, primaryBreedInput, 'breed'))
        }

        // Cross breed
        const detailsEl = this.element.querySelector('details')
        if (detailsEl) {
          const secondaryBreedInput = detailsEl.querySelector('input[name*="additional_breed"]')
          if (secondaryBreedInput) {
            secondaryBreedInput.addEventListener('change', () =>
              this.updateBreed(dogIndex, secondaryBreedInput, 'additional_breed')
            )
          }

          detailsEl.addEventListener('toggle', () => this.handleDetailsToggle(dogIndex, detailsEl))
        }
      }

      updateBreed(dogIndex, input, field) {
        const dog = Dog.find(dogIndex)

        if (dog) {
          dog[field] = input.value || null
          dog.save()
          this.updateRecap()
        }
      }

      handleDetailsToggle(dogIndex, detailsEl) {
        // Clear secondary breed on close toggle
        if (!detailsEl.open) {
          const hiddenInput = detailsEl.querySelector('input[name*="additional_breed"]')
          const searchInput = detailsEl.querySelector('[id^="additional-breed-select"]')
          const dog = Dog.find(dogIndex)

          // Reset form and Dog object, persist change and update recap
          if (dog && hiddenInput) {
            hiddenInput.value = ''
            if (searchInput) searchInput.value = ''
            dog.additional_breed = null
            dog.save()
            this.updateRecap()
          }
        }
      }

      closeAdditionalBreed() {
        const detailsEl = this.element.querySelector('details')
        if (detailsEl && detailsEl.open) {
          detailsEl.open = false
        }
      }

      updateRecap() {
        // Update breed slot
        const recapElement = document.querySelector('[data-controller="quiz-recap"]')
        if (recapElement) {
          const recapController = Stimulus.getControllerForElementAndIdentifier(recapElement, 'quiz-recap')
          if (recapController) recapController.render()
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz--steps--health-issues"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'health-issues',
    class extends Stimulus.Controller {
      static targets = ['fieldset', 'checkbox', 'yes']

      connect() {
        this.toggle()
      }

      toggle() {
        if (this.yesTarget.checked) {
          this.fieldsetTarget.style.display = 'flex'
          this.checkboxTargets.forEach((checkbox) => {
            checkbox.dataset.required = 'true'
          })
        } else {
          this.fieldsetTarget.style.display = 'none'
          this.checkboxTargets.forEach((checkbox) => {
            checkbox.checked = false
            checkbox.removeAttribute('data-required')
          })
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz--steps--weight"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'weight-validation',
    class extends Stimulus.Controller {
      static targets = ['weight', 'alert']
      static values = { maxWeight: 200, alertThreshold: 100 }

      // Sanitize - numerical only via regexp
      validateWeight() {
        const input = this.weightTarget
        let value = input.value

        value = value.replace(/[^\d.]/g, '')

        // Prevent multiple decimal points
        const parts = value.split('.')
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('')
        }

        input.value = value

        const weight = parseFloat(value)

        // Cap weight at max limit and show alert banner if exceeded
        if (weight > this.maxWeightValue) {
          input.value = this.maxWeightValue
          this.alertTarget.style.display = 'block'
        } else if (weight > this.alertThresholdValue) {
          this.alertTarget.style.display = 'block'
        } else {
          this.alertTarget.style.display = 'none'
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz-banner"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--quiz-banner',
    class extends Stimulus.Controller {
      dismiss(event) {
        const alertElement = event.target.closest('.alert')
        if (alertElement) {
          alertElement.style.display = 'none'
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz-recap"] && !Shopify.designMode) return;
  try {
    let { render, tag, Dog } = DogHeroes

  Stimulus.register(
    'quiz-recap',
    class extends Stimulus.Controller {
      static targets = ['dogsContainer', 'title']

      static values = {
        sexes: { male: 'Maschietto', female: 'Femminuccia' },
      }

      connect() {
        this.algorithmData = DogHeroes.algorithmData
        this.stepMap = {
          breed: 1,
          gender: 2,
          age: 3,
          weight: 4,
          diet: 7,
          allergies: 8,
          diseases: 9,
        }
        this.render()
        const handleButtonAction = (e) => {
          let button = e.target.closest('.quiz-recap-button')
          if (button) {
            // Check list item buttons first
            let step = button.closest('[data-quiz-step]')?.dataset.quizStep
            // Fallback to description button data attribute
            if (!step) step = button.dataset.descriptionStep
            if (step) this.navigateToStep(step)
          }
        }
        this.element.addEventListener('click', handleButtonAction)
        this.element.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            let button = e.target.closest('.quiz-recap-button')
            if (button) {
              e.preventDefault()
              handleButtonAction(e)
            }
          }
        })
      }

      shouldRender(dog) {
        if (!dog) return false
        if (dog.breed || dog.sex || dog.weight) return true
        return false
      }

      render() {
        const dogs = Dog.all().filter((dog) => this.shouldRender(dog))
        requestAnimationFrame(() => {
          this.element.innerHTML = ''
          dogs.forEach((dog) => {
            let dogElement = this.renderDog(dog)
            this.element.appendChild(dogElement)
          })
          this.element.toggleAttribute('hidden', dogs.length === 0)
        })
      }

      renderDog(dog) {
        let { allergies, breed, additional_breed, build, diet, diseases, sex, sterilization, weight } = dog.attributes()

        let getBreed = (breed) => {
          return this.algorithmData.dog_breeds.find((b) => b.handle === breed)?.name || breed
        }

        let createDescriptionElement = (content, step) => {
          let p = document.createElement('p')
          let button = document.createElement('button')
          button.type = 'button'
          button.className = 'quiz-recap-button'
          button.innerHTML = content
          button.setAttribute('data-description-step', step)
          p.appendChild(button)
          return p
        }

        let descriptions = []
        if (weight && build) {
          let weightDescription = `Pesa <strong>${weight}kg</strong>`
          let weightLabel = this.algorithmData.body_condition_factor.find((b) => b.handle === build)?.label
          let bodyCondition = ` e la sua corporatura è ${weightLabel}`
          descriptions.push([weightDescription + bodyCondition, 'weight'])
        }
        if (sterilization) {
          let suffix = sex === 'female' ? 'a' : 'o'
          let sterilizationLabel = sterilization === 'yes' ? `Sterilizzat${suffix}` : `Non sterilizzat${suffix}`
          descriptions.push([sterilizationLabel, 'gender'])
        }
        if (diet)
          descriptions.push([`Dieta attuale: <strong>${diet?.join(', ') || 'non specificata'}</strong>`, 'diet'])
        if (allergies)
          descriptions.push([`Allergie: <strong>${allergies?.join(', ') || 'nessuna'}</strong>`, 'allergies'])
        if (diseases)
          descriptions.push([`Problemi di salute: <strong>${diseases?.join(', ') || 'nessuno'}</strong>`, 'diseases'])

        let element = render('dh-quiz-recap-dog', {
          name: dog.displayName,
          breed: [getBreed(additional_breed), getBreed(breed)].filter(Boolean).join(' X '),
          male: sex === 'male' ? this.sexesValue[sex] : '',
          female: sex === 'female' ? this.sexesValue[sex] : '',
          age: dog.age?.toString(),
          description: descriptions.filter(Boolean).map(([desc, step]) => createDescriptionElement(desc, step)),
        })

        // Remove empty list items
        element.querySelectorAll('li').forEach((el) => el.textContent.trim() === '' && el.remove())

        return element
      }

      navigateToStep(stepName) {
        let stepIndex = this.stepMap[stepName]
        if (stepIndex === undefined) return

        let quizElement = document.querySelector('[data-controller="quiz"]')
        if (!quizElement) return

        let quizController =
          quizElement.stimulusController || Stimulus.getControllerForElementAndIdentifier(quizElement, 'quiz')
        if (quizController) quizController.setCurrentStep(stepIndex)
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--quiz"] && !Shopify.designMode) return;
  try {
    const { Dog } = DogHeroes

  Stimulus.register(
    'quiz',
    class extends Stimulus.Controller {
      static targets = ['step', 'prevButton', 'nextButton', 'loaderModal']

      static values = {
        currentStep: { type: Number, default: 0 }, // zero-based index
        stepKey: { type: String, default: 'dogheroes.quiz' },
        quizStartedAtKey: { type: String, default: 'dogheroes.quiz_started_at' },
        customerFirstName: { type: String, default: '' },
        customerLastName: { type: String, default: '' },
        customerEmail: { type: String, default: '' },
        customerId: { type: String, default: '' },
        customerDogHandles: { type: Array, default: [] },
      }

      connect() {
        this.cleanupKnownDogs()
        this.renderDogs()
        this.restoreSavedData()
        this.setCurrentStep(localStorage.getItem(this.stepKeyValue))
        this.hideLoaderModal()
        this.initQuizStartedAt()
        this.pushQuizOpenDataLayerEvent()
        window.addEventListener('pageshow', this.handlePageShow.bind(this))
      }

      disconnect() {
        window.removeEventListener('pageshow', this.handlePageShow.bind(this))
      }

      initQuizStartedAt() {
        if (!localStorage.getItem(this.quizStartedAtKeyValue)) {
          localStorage.setItem(this.quizStartedAtKeyValue, new Date().toISOString())
        }
      }

      handlePageShow(event) {
        if (
          event.persisted ||
          performance.getEntriesByType('navigation').some((entry) => entry.type === 'back_forward')
        ) {
          this.hideLoaderModal()
        }
      }

      hideLoaderModal() {
        if (!this.hasLoaderModalTarget) return

        this.loaderModalTarget.hidden = true
        this.loaderModalTarget.classList.remove('dogheroes--quiz-loader-modal--visible')
      }

      // If a dog from localStorage matches any of the customer's dogs
      // it means the quiz was completed and we can drop that dog.
      cleanupKnownDogs() {
        console.log('Cleaning up known dogs...', this.customerDogHandlesValue)
        let needsReload = false
        Dog.all().forEach((dog) => {
          console.log('Checking dog:', dog.handle)
          if (this.customerDogHandlesValue.includes(dog.handle)) {
            dog.destroy()
            this.setCurrentStep(0)
            needsReload = true
          }
        })
        // Reloading the page is necessary to reset the quiz state and start fresh for the user.
        if (needsReload) location.reload()
      }

      get currentStepElement() {
        return this.stepTargets[this.currentStepValue]
      }

      get isLastStep() {
        return this.currentStepValue === this.stepTargets.length - 1
      }

      get isFirstStep() {
        return this.currentStepValue === 0
      }

      // Link the anonymous browser session (Klaviyo __kla_id cookie) to the
      // lead's email so onsite flows (Viewed Product, Active on Site, etc.)
      // can attribute events to the right profile. Runs after every completed
      // step so identification starts as soon as the email is left, not only
      // at quiz completion — abandoned quizzes must still get onsite
      // attribution. The actual subscription — consent, list, profile
      // attributes — is created server-side by UpsertCustomerToKlaviyoJob
      // from the quiz POST handler.
      notifyKlaviyo() {
        const email = this.element.elements['quiz[customer_email]'].value
        if (!email || email === this.lastIdentifiedEmail) return

        if (typeof klaviyo === 'undefined') {
          console.warn('Klaviyo is not defined. Skipping Klaviyo notification.')
          return
        }

        this.lastIdentifiedEmail = email
        klaviyo.identify({ email: email })
      }

      async next(event) {
        //console.log('next() called', { eventType: event.type, eventTarget: event.target, currentStep: this.currentStepValue })

        // Block Enter on previous button — let previous() handle it instead
        if (
          event.type === 'keydown' &&
          event.key === 'Enter' &&
          this.hasPrevButtonTarget &&
          event.target === this.prevButtonTarget
        ) {
          return
        }

        // Only respond to real user events: form submit, trusted keyboard, or pointer clicks.
        // Synthetic events (browser autofill, password managers) are not trusted and must
        // never advance the quiz, even though they can mimic an Enter keydown on an input.
        if (event instanceof KeyboardEvent && !event.isTrusted) return
        if (event instanceof KeyboardEvent && event.key !== 'Enter') return

        // Enter must only advance when the current step is valid. We read validity live
        // via isCurrentStepValid() rather than the next button's `disabled` property, which
        // can be stale when fields are pre-filled (breed/age restore asynchronously and may
        // not have re-synced the button yet). The breed/age custom dropdowns stop Enter from
        // bubbling here while open, so this never fires mid-selection.
        if (event.type === 'keydown' && !this.isCurrentStepValid()) {
          event.preventDefault()
          return
        }

        event.preventDefault()

        // Prevent autofill-triggered form submissions on all steps.
        // When autofill auto-submits the form, event.type is 'submit' (not 'click').
        if (event.type === 'submit') {
          event.preventDefault()
          return
        }

        if (this.isLastStep) {
          if (!this.isCurrentStepValid()) return

          await this.saveCurrentStep()
          this.pushQuizCompletedDataLayerEvent(this.currentStepValue)
          this.notifyKlaviyo()
          this.showLoaderModal()

          let appendHiddenInput = (name, value) => {
            let input = document.createElement('input')
            input.type = 'hidden'
            input.name = name
            input.value = value
            this.element.appendChild(input)
          }

          // Add an hidden field with the calories count for each dog to be processed in the backend
          const dogs = Dog.all()

          dogs.forEach((dog, index) => {
            appendHiddenInput(`quiz[${index}][handle]`, dog.handle)
            appendHiddenInput(`quiz[${index}][daily_calories]`, dog.daily_calories || 0)
          })

          // Forward the quiz_started_at timestamp from localStorage so the
          // server-side Klaviyo subscribe job can record quiz_first_seen.
          appendHiddenInput('quiz[quiz_started_at]', localStorage.getItem(this.quizStartedAtKeyValue) || '')

          this.element.submit()
          return
        }

        if (!this.isCurrentStepValid()) return

        await this.saveCurrentStep()
        this.notifyKlaviyo()
        this.pushStepCompletedDataLayerEvent(this.currentStepValue)
        this.setCurrentStep(this.currentStepValue + 1)
        this.dispatch('nextStep', {
          detail: { currentStep: this.currentStepValue },
        })
      }

      pushQuizOpenDataLayerEvent() {
        const payload = {
          event: 'quiz_open',
          quiz_type: 'dog',
        }

        this.pushToDataLayer(payload)
      }

      pushStepCompletedDataLayerEvent(submittedStepIndex) {
        const payload = {
          event: 'quiz_step_completed',
          step_number: submittedStepIndex + 1,
          quiz_type: 'dog',
          dogs: this.collectDogsForStep(submittedStepIndex),
        }

        this.pushToDataLayer(payload)
      }

      pushQuizCompletedDataLayerEvent(submittedStepIndex) {
        const payload = {
          event: 'quiz_completed',
          quiz_type: 'dog',
          user_name: this.getFormFieldValue('quiz[customer_name]'),
          user_email: this.getFormFieldValue('quiz[customer_email]'),
          user_phone: this.getFormFieldValue('quiz[customer_phone]'),
          user_zip_code: this.getFormFieldValue('quiz[customer_zip]'),
          dogs: this.collectDogsForStep(submittedStepIndex),
        }

        this.pushToDataLayer(payload)
      }

      buildUserData() {
        return {
          first_name: this.customerFirstNameValue || null,
          last_name: this.customerLastNameValue || null,
          email: this.customerEmailValue || null,
          customer_id: this.customerIdValue || null,
          shopify_client_id: this.shopifyClientId(),
        }
      }

      pushToDataLayer(payload) {
        window.dataLayer = window.dataLayer || []
        const fullPayload = {
          ...payload,
          user_data: this.buildUserData(),
        }
        if (typeof window.dataLayer === 'undefined') {
          console.warn('dataLayer is not defined. Cannot push event:', fullPayload)
          return
        }
        console.log('Pushing to dataLayer:', fullPayload)
        window.dataLayer.push(fullPayload)
      }

      getFormFieldValue(name) {
        const value = this.element.elements[name]?.value
        if (typeof value !== 'string') return value || null

        const trimmedValue = value.trim()
        return trimmedValue === '' ? null : trimmedValue
      }

      collectDogsForStep(submittedStepIndex) {
        const dogs = []
        const elements = Array.from(this.element.elements).filter((element) => {
          if (!element.name) return false
          const stepElement = element.closest("[data-quiz-target='step']")
          if (!stepElement) return false

          const inputStep = parseInt(stepElement.dataset.step, 10)
          return !isNaN(inputStep) && inputStep <= submittedStepIndex
        })

        elements.forEach((input) => {
          const index = this.getInputIndex(input)
          const key = this.getInputKey(input)

          if (index == null || key == null) return

          if (!dogs[index]) dogs[index] = { index: index }

          const serializedEntry = this.serializeDogField(input, key)
          if (!serializedEntry) return

          const [fieldName, fieldValue] = serializedEntry
          dogs[index][fieldName] = fieldValue
        })

        return dogs.filter(Boolean)
      }

      serializeDogField(input, key) {
        let value = null

        if (input.type === 'radio') {
          if (!input.checked) return null
          value = input.value
        } else if (input.type === 'checkbox' && input.hasAttribute('data-checkbox-multiple')) {
          const index = this.getInputIndex(input)
          const allCheckboxes = input.form.querySelectorAll(
            `input[type="checkbox"][data-checkbox-multiple][name="quiz[${index}][${key}]"]`
          )
          value = Array.from(allCheckboxes)
            .filter((checkbox) => checkbox.checked)
            .map((checkbox) => checkbox.value)

          if (value.length === 0) return null
        } else if (input.type === 'checkbox') {
          value = input.checked ? 'yes' : 'no'
        } else {
          value = typeof input.value === 'string' ? input.value.trim() : input.value
          if (value == null || value === '') return null
        }

        return [key, value]
      }

      shopifyClientId() {
        const match = document.cookie.match(/(?:^|; )shopify_client_id=([^;]+)/)
        return match ? decodeURIComponent(match[1]) : null
      }

      setCurrentStep(step) {
        if (!step) step = 0
        if (isNaN(step)) step = 0
        if (step < 0 || step >= this.stepTargets.length) step = 0

        this.currentStepValue = step
        localStorage.setItem(this.stepKeyValue, this.currentStepValue)
        this.renderCurrentStep()
      }

      async previous(event) {
        //console.log('previous() called', { eventType: event.type, eventTarget: event.target, currentStep: this.currentStepValue })
        if (this.isFirstStep) return

        // Block any keydown events on inputs from going back.
        // Autofill can trigger keydown events that match the form's listeners.
        if (event.type === 'keydown' && event.target instanceof HTMLInputElement) {
          console.log('Blocking keydown on input')
          event.preventDefault()
          return
        }

        // Only respond to real user events: trusted keyboard or pointer clicks
        if (event instanceof KeyboardEvent && !event.isTrusted) return
        if (event instanceof KeyboardEvent) {
          // Escape goes back a step (from anywhere in the step). Enter goes back only when
          // the back button itself is focused, so it doesn't fight with next().
          const isPrevButtonFocused = event.target === this.prevButtonTarget
          const isEscape = event.key === 'Escape'
          const isEnterOnButton = event.key === 'Enter' && isPrevButtonFocused
          if (!isEscape && !isEnterOnButton) return
        }

        event.preventDefault()

        await this.saveCurrentStep()
        this.setCurrentStep(this.currentStepValue - 1)
        this.dispatch('previousStep', {
          detail: { currentStep: this.currentStepValue },
        })
      }

      renderCurrentStep() {
        this.stepTargets.forEach((step, index) => {
          step.classList.toggle('active', index === this.currentStepValue)
        })

        this.updateDogNamePlaceholders()
        this.updateProgressStepper()
        this.renderButtons()

        this.scrollToTop()
        this.focusCurrentStep()
      }

      // Move focus into the active step so the form-scoped `keydown.enter` shortcut works
      // even on pre-filled steps where the user hasn't focused any field yet. Without this,
      // focus stays on <body> (outside the form), the Enter keydown never bubbles to the
      // form, and pressing Enter does nothing until the user interacts with a field.
      // The container is focused (not a field) so the breed/age dropdowns don't auto-open.
      focusCurrentStep() {
        const step = this.currentStepElement
        if (!step) return
        if (!step.hasAttribute('tabindex')) step.setAttribute('tabindex', '-1')
        step.focus({ preventScroll: true })
      }

      updateProgressStepper() {
        const currentStep = this.stepTargets[this.currentStepValue]
        if (!currentStep) return

        const currentMainStep = currentStep.dataset.mainStep
        if (!currentMainStep) return

        const progressSteps = document.querySelectorAll('.quiz-progress-step[data-main-step]')
        progressSteps.forEach((progressStep) => {
          const mainStep = progressStep.dataset.mainStep
          const mainStepNum = parseInt(mainStep)
          const currentMainStepNum = parseInt(currentMainStep)

          progressStep.classList.remove('active', 'completed')

          if (mainStepNum === currentMainStepNum) {
            progressStep.classList.add('active')
            progressStep.setAttribute('aria-current', 'step')
          } else if (mainStepNum < currentMainStepNum) {
            progressStep.classList.add('completed')
            progressStep.removeAttribute('aria-current')
          } else {
            progressStep.removeAttribute('aria-current')
          }
        })
      }

      addDog() {
        Dog.create()
        this.renderDogs()
      }

      removeDog(event) {
        let dogs = Dog.all()
        let index = parseInt(event.target.closest('[data-dog-fieldset]').dataset.dog)

        if (dogs.length <= 1) return

        dogs[index].destroy()
        this.renderDogs()
      }

      renderDogs() {
        let dogs = Dog.all()
        if (dogs.length === 0) {
          Dog.create()
          dogs = Dog.all()
        }

        // If any dog doesn't have a name, we should start over
        if (dogs.some((dog) => !dog.name)) this.setCurrentStep(0)

        let replaceAttribute = (el, attr, index) => {
          if (el.hasAttribute(attr)) {
            el.setAttribute(attr, el.getAttribute(attr).replace('__INDEX__', index))
          }
        }

        this.stepTargets.forEach((step) => {
          let dogFieldsets = step.querySelectorAll('div[data-dog-fieldset]')

          let length = Math.max(dogs.length, dogFieldsets.length)
          for (let i = 0; i < length; i++) {
            let dog = dogs[i]
            let fieldset = dogFieldsets[i]

            if (!dog && fieldset) {
              fieldset.remove()
              continue
            }

            if (dog && !fieldset) {
              const template = step.querySelector('template')
              const clonedFieldsContainer = step.querySelector('div[data-fields-container]')

              if (template) {
                const content = template.content.cloneNode(true)
                clonedFieldsContainer.appendChild(content)
                fieldset = clonedFieldsContainer.lastElementChild
              }
            }

            if (dog && fieldset) {
              let index = i

              fieldset.dataset.dog = index
              const inputs = fieldset.querySelectorAll("[data-quiz-target~='input']")
              const labels = fieldset.querySelectorAll('[data-quiz-field-label]')

              inputs.forEach((input) => {
                replaceAttribute(input, 'name', index)
                replaceAttribute(input, 'id', index)
              })

              labels.forEach((label) => replaceAttribute(label, 'for', index))

              fieldset.querySelectorAll('[data-replace]').forEach((el) => {
                el.getAttribute('data-replace')
                  .split(',')
                  .forEach((attr) => replaceAttribute(el, attr.trim(), index))
                el.removeAttribute('data-replace')
              })

              // Legacy
              fieldset.querySelectorAll('[data-replace-for]').forEach((label) => {
                replaceAttribute(label, 'for', index)
                label.removeAttribute('data-replace-for')
              })
              fieldset.querySelectorAll('[data-replace-id]').forEach((el) => {
                replaceAttribute(el, 'id', index)
                el.removeAttribute('data-replace-id')
              })
              fieldset.querySelectorAll('[data-replace-aria]').forEach((el) => {
                replaceAttribute(el, 'aria-controls', index)
                replaceAttribute(el, 'aria-labelledby', index)
                el.removeAttribute('data-replace-aria')
              })
              fieldset.querySelectorAll('[data-dog-index]').forEach((input) => {
                input.dataset.dogIndex = index
              })
            }
          }
        })

        let dogCount = dogs.length
        let showButtons = dogCount > 1

        this.stepTargets.forEach((step) => {
          let removeButtons = step.querySelectorAll('.remove-dog-button')
          removeButtons.forEach((button) => {
            button.style.display = showButtons ? 'flex' : 'none'
          })
        })
      }

      isCurrentStepValid() {
        let activeStep = this.currentStepElement
        let inputs = Array.from(activeStep.querySelectorAll('[data-required]')).filter((input) => !input.disabled)

        if (inputs.length === 0) {
          this.nextButtonTarget.disabled = false
          return true
        }

        let allFilled = inputs.every((input) => {
          if (input.type === 'radio') {
            return document.querySelectorAll(`input[name="${input.name}"]:checked`).length > 0
          }

          if (input.type === 'checkbox') {
            if (input.hasAttribute('data-checkbox-multiple')) {
              let checkboxes = document.querySelectorAll(
                `input[type="checkbox"][data-checkbox-multiple][name="${input.name}"]`
              )
              return Array.from(checkboxes).some((cb) => cb.checked)
            }
            return input.checked
          }

          return input.value.trim() !== ''
        })

        return allFilled
      }

      renderButtons() {
        if (this.hasPrevButtonTarget) {
          this.prevButtonTarget.style.display = this.isFirstStep ? 'none' : ''
        }

        if (this.hasNextButtonTarget) {
          this.nextButtonTarget.textContent = this.isFirstStep
            ? 'Iniziamo'
            : this.isLastStep
              ? 'Salva e prosegui'
              : 'Prosegui'
        }

        this.nextButtonTarget.disabled = !this.isCurrentStepValid()
      }

      showLoaderModal() {
        if (!this.hasLoaderModalTarget) return

        this.loaderModalTarget.hidden = false
        this.loaderModalTarget.classList.add('dogheroes--quiz-loader-modal--visible')
      }

      scrollToTop() {
        const container = this.element.closest('.quiz-container')
        if (container) {
          container.scrollTo(0, 0)
        }
        window.scrollTo(0, 0)
      }

      saveCurrentStep() {
        let currentStep = this.currentStepValue

        let dogs = Dog.all()

        let form = this.element
        let elements = Array.from(form.elements).filter((e) => e.name)

        for (let input of elements) {
          if (input.type === 'radio' && !input.checked) continue

          const stepEl = input.closest("[data-quiz-target='step']")
          if (!stepEl) continue

          const inputStep = parseInt(stepEl.dataset.step, 10)
          if (isNaN(inputStep) || inputStep > currentStep) continue

          let index = this.getInputIndex(input)
          let key = this.getInputKey(input)
          let dog = dogs[index]
          let value = this.getInputValue(input)

          if (key != null && dog != null && value != null) {
            dog[key] = value
          }
        }

        dogs.map((dog) => {
          let calories = dog.dailyCalories()
          dog.daily_calories = Math.round(calories)
        })

        dogs.forEach((dog) => dog.save())

        // Persist customer contact fields to localStorage so they survive the
        // post-quiz navigation. The recipes page reads `customer_zip` to fetch
        // delivery timeline data, and the proceed-to-checkout flow reads all of
        // these to prefill the Shopify checkout (see assets/dogheroes--saved-cart.js).
        const leadFields = {
          'dogheroes.customer_name': 'quiz[customer_name]',
          'dogheroes.customer_email': 'quiz[customer_email]',
          'dogheroes.customer_phone': 'quiz[customer_phone]',
          'dogheroes.customer_zip': 'quiz[customer_zip]',
        }
        for (let [storageKey, fieldName] of Object.entries(leadFields)) {
          let input = form.elements[fieldName]
          if (input && input.value) {
            localStorage.setItem(storageKey, input.value)
          }
        }
      }

      restoreSavedData() {
        const dogs = Dog.all()

        this.stepTargets.forEach((step) => {
          const inputs = step.querySelectorAll("[data-quiz-target~='input']")

          inputs.forEach((input) => {
            const key = this.getInputKey(input)
            const dogIndex = this.getInputIndex(input)
            const dog = dogs[dogIndex]

            if (key && dog && dog[key] != null) {
              this.setInputValue(input, dog[key])
              if (key.includes('additional_breed') && dog[key]) input.closest('details').open = true
            }
          })
        })

        this.dispatch('restoreData')
      }

      getInputKey(input) {
        const match = input.name.match(/quiz\[\w+\]\[(\w+)\]/)
        return match ? match[1] : null
      }

      getInputIndex(input) {
        const match = input.name.match(/quiz\[(\w+)\]\[\w+\]/)
        return match ? parseInt(match[1], 10) : null
      }

      getInputValue(input) {
        if (input.type === 'checkbox' && input.hasAttribute('data-checkbox-multiple')) {
          let allCheckboxes = input.form.querySelectorAll(
            `input[type="checkbox"][data-checkbox-multiple][name="${input.name}"]`
          )
          let checkedValues = Array.from(allCheckboxes)
            .filter((cb) => cb.checked)
            .map((cb) => cb.value)
          return checkedValues
        }

        if (input.type === 'checkbox') {
          return input.checked ? 'yes' : 'no'
        }
        return input.value
      }

      updateDogNamePlaceholders() {
        let dogNames = Dog.all().map((dog) => dog.displayName)
        let dogNameElements = dogNames.map((name) => `<span>${name}</span>`)
        // Join with a comma, use "e" for the last separator
        let joinedDogNames =
          dogNameElements.slice(0, -1).join(', ') +
          (dogNameElements.length > 1 ? ' e ' : '') +
          dogNameElements.slice(-1)

        this.element.querySelectorAll('[data-dog-names]').forEach((el) => {
          el.innerHTML = joinedDogNames
        })

        this.stepTargets.forEach((step) => {
          const groupedByDog = step.querySelectorAll('[data-dog-fieldset]')
          groupedByDog.forEach((group, index) => {
            const dogNamePlaceholders = group.querySelectorAll('[data-dog-name]')

            dogNamePlaceholders.forEach((el) => {
              el.textContent = dogNames[index]
            })
          })
        })
      }

      setInputValue(input, value) {
        if (input.type === 'checkbox') {
          if (input.hasAttribute('data-checkbox-multiple')) {
            input.checked = Array.isArray(value) && value.includes(input.value)
          } else {
            input.checked = value === 'yes'
          }
        } else if (input.type === 'radio') {
          input.checked = input.value === value
        } else {
          const rangeSlider = input.closest('range-slider')
          if (rangeSlider) {
            rangeSlider.dataset.selectedHandle = value
          }
          input.value = value
        }
      }

      sanitizePhone(event) {
        const input = event.target
        let value = input.value
        value = value.replace(/[^\d]/g, '')

        if (value.length > 10) {
          value = value.slice(0, 10)
        }

        if (value.length > 6) {
          value = `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6)}`
        } else if (value.length > 3) {
          value = `${value.slice(0, 3)} ${value.slice(3)}`
        }

        input.value = value
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes--steps--cart-recap"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'cart-recap',
    class extends Stimulus.Controller {
      static targets = [
        'discountedPrice',
        'dogsContainer',
        'dailyPrice',
        'trialDeliveryDate',
        'trialTotalPrice',
        'paymentReminderDate',
        'subscriptionStartDate',
        'subscriptionPrice',
        'entireDailyPrice',
        'totalPrice',
      ]

      static values = {
        discount: Number,
      }

      connect() {
        this.#syncTrialPriceFromFooter()
        this.totalPriceObserver = new MutationObserver(() => this.#syncTrialPriceFromFooter())
        this.totalPriceObserver.observe(this.totalPriceTarget, {
          childList: true,
          characterData: true,
          subtree: true,
        })
      }

      disconnect() {
        this.totalPriceObserver?.disconnect()
      }

      async loadTimeline() {
        // The CAP (ZIP) is persisted to localStorage by the quiz on /pages/quiz
        // (see dogheroes--quiz.liquid `saveCurrentStep`). On /pages/recipes we
        // read it back and ask the backend for delivery-aware timeline data.
        this.#renderFinalPrices()

        const zip = localStorage.getItem('dogheroes.customer_zip') || '00000'
        const hasFrozen = this.#hasFrozenProducts()
        const data = await this.fetchTimelineData(zip, hasFrozen)
        if (!data) return

        this.renderTimeline(data)
      }

      #hasFrozenProducts() {
        const subscriptions = DogHeroes.savedCart?.subscriptions || []
        const products = DogHeroes.productsByHandle || {}

        return subscriptions.some((subscription) => {
          return Object.values(subscription).some((recipe) => {
            const productHandle = recipe.productHandle
            const product = products[productHandle]
            return product?.tags?.includes('frozen')
          })
        })
      }

      async fetchTimelineData(zip, hasFrozen = false) {
        const url = new URL('https://dogheroes-production-68e629138b57.herokuapp.com/delivery_dates')
        url.searchParams.set('cap', zip)
        if (hasFrozen) {
          url.searchParams.set('has_frozen', 'true')
        }

        try {
          const response = await fetch(url)
          if (!response.ok) throw new Error('Network response was not ok')
          return await response.json()
        } catch (error) {
          console.error('Failed to fetch timeline data:', error)
          return null
        }
      }

      renderTimeline(data) {
        const earliest = new Date(data.earliest)
        const trialDeliveryDate = earliest.toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
        })
        this.trialDeliveryDateTarget.textContent = `${trialDeliveryDate}`

        const paymentReminderDate = new Date(earliest)
        paymentReminderDate.setDate(paymentReminderDate.getDate() + 10)
        this.paymentReminderDateTarget.textContent = `${paymentReminderDate.toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
        })}`

        const subscriptionStartDate = new Date(earliest)
        subscriptionStartDate.setDate(subscriptionStartDate.getDate() + 14)
        this.subscriptionStartDateTarget.textContent = `${subscriptionStartDate.toLocaleDateString('it-IT', {
          day: 'numeric',
          month: 'long',
        })}`
      }

      updatePrices(event) {
        const { savedCart } = event.detail

        const dailyPrice = DogHeroes.savedCart.subscriptionsDailySubtotal(14)
        const discountedDailyPrice = (dailyPrice * (1 - this.discountValue / 100)) / 100

        this.discountedPriceTarget.textContent = `€${discountedDailyPrice.toFixed(2).replace('.', ',')}`
        this.dailyPriceTarget.textContent = `€${(dailyPrice / 100).toFixed(2).replace('.', ',')}`
        this.entireDailyPriceTarget.textContent = `€${(dailyPrice / 100).toFixed(2).replace('.', ',')}`
        this.subscriptionPriceTarget.textContent = `€${((dailyPrice * 28) / 100).toFixed(2).replace('.', ',')}`
        this.#renderFinalPrices()

        this.renderDogs(savedCart)
      }

      #finalTotalCents() {
        // "Box di prova" is an ORDER-level automatic discount (a single
        // percentage off the whole subscription subtotal, first payment only),
        // so Shopify computes it once on the subtotal and rounds. Replicate
        // that exactly: summing per-line floors under-counts the discount and
        // drifts a cent or two above the real checkout total.
        const subscriptionSubtotalCents = DogHeroes.savedCart.subscriptions.reduce((total, dogSubscriptions) => {
          return (
            total +
            Object.values(dogSubscriptions).reduce((subtotal, { quantity, price }) => subtotal + quantity * price, 0)
          )
        }, 0)
        const discountedSubscriptionsCents =
          subscriptionSubtotalCents - Math.round((subscriptionSubtotalCents * this.discountValue) / 100)
        const oneTimeCents = Math.round(DogHeroes.savedCart.oneTimePurchasesTotal * 100)
        return discountedSubscriptionsCents + oneTimeCents
      }

      #renderFinalPrices() {
        const finalTotal = `€${(this.#finalTotalCents() / 100).toFixed(2).replace('.', ',')}`
        this.trialTotalPriceTarget.textContent = finalTotal
        this.totalPriceTarget.textContent = finalTotal
      }

      #syncTrialPriceFromFooter() {
        const totalPrice = this.totalPriceTarget.textContent?.trim()
        if (!totalPrice) return
        this.trialTotalPriceTarget.textContent = totalPrice
      }

      renderDogs(savedCart) {
        const dogs = DogHeroes.Dog.all()
        const container = this.dogsContainerTarget

        container.querySelectorAll('[data-rendered]').forEach((el) => el.remove())

        dogs.forEach((dog, dogIndex) => {
          const subscriptions = savedCart?.subscriptions?.[dogIndex] || {}
          const entries = Object.values(subscriptions)
          if (entries.length === 0) return

          const totalGrams = entries.reduce(
            (sum, { quantity, weightInGrams }) => sum + (quantity || 0) * (weightInGrams || 0),
            0
          )
          const dailyGrams = Math.round(totalGrams / 14)

          const fragment = DogHeroes.render('cart-recap-dog-template', {
            'dog-name': dog.displayName,
            'daily-grams': String(dailyGrams),
            quantity: entries.reduce((sum, { quantity }) => sum + (quantity || 0), 0),
          })

          const el = fragment.firstElementChild
          if (el) {
            el.setAttribute('data-rendered', '')

            const firstProductHandle = entries[0]?.productHandle
            const sourceImg = firstProductHandle
              ? container.querySelector(`[data-product-image-for="${firstProductHandle}"] img`)
              : null
            const targetImg = el.querySelector('.image img')
            if (sourceImg && targetImg) {
              targetImg.src = sourceImg.src
              targetImg.alt = sourceImg.alt
            }
          }

          container.appendChild(fragment)
        })
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes--steps--cross-sell"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'cross-sell',
    class extends Stimulus.Controller {
      static targets = ['counter', 'variant', 'buttonText']

      get cart() {
        return DogHeroes.savedCart
      }

      connect() {}

      increment(event) {
        let index = event.params.index
        let { id, quantity, price } = this.variantTargets[index].dataset
        let updatedQuantity = parseInt(quantity) + 1

        this.variantTargets[index].dataset.quantity = updatedQuantity
        this.counterTargets[index].textContent = updatedQuantity
        this.updateItems(id, updatedQuantity, price / 100)
      }

      decrement(event) {
        let index = event.params.index
        let { id, quantity, price } = this.variantTargets[index].dataset

        if (quantity > 0) {
          let updatedQuantity = parseInt(quantity) - 1
          this.variantTargets[index].dataset.quantity = updatedQuantity
          this.counterTargets[index].textContent = updatedQuantity
          this.updateItems(id, updatedQuantity, price / 100)
        }
      }

      updateItems(id, quantity, price) {
        let itemId = parseInt(id)

        if (quantity === 0) {
          delete this.cart.oneTimePurchases[itemId]
        } else {
          this.cart.oneTimePurchases[itemId] = {
            quantity,
            price: parseFloat(price),
          }
        }

        this.updateButton()
        this.dispatch('quantityUpdated')
      }

      updateButton() {
        let total = this.cart.oneTimePurchasesTotal
        if (total > 0) {
          this.buttonTextTarget.textContent = `Aggiungi • €${total.toFixed(2).replace('.', ',')}`
        } else {
          this.buttonTextTarget.textContent = 'Prosegui'
        }
      }

      async submitForm(event) {
        event.preventDefault()

        // Fire one extra_selected per dog on every pass through the step, even
        // with no extras picked, so the data layer always records it.
        this.#pushExtraSelectedEvents()

        let itemsToAdd = Object.entries(this.cart.oneTimePurchases).map(([id, item]) => ({
          id: parseInt(id),
          quantity: item.quantity,
        }))

        if (itemsToAdd.length === 0) return

        try {
          let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd }),
          })
          if (!response.ok) {
            console.error('Failed to add items to cart. Response status:', response.status)
          }
        } catch (error) {
          console.error('Network error while adding items to cart:', error)
        }
      }

      #pushExtraSelectedEvents() {
        let extraProducts = this.#extraProductsText()

        DogHeroes.Dog.all().forEach((dog, index) => {
          let recipes = Object.values(this.cart.subscriptions[index] || {})
          DogHeroes.pushToDataLayer({
            event: 'extra_selected',
            quiz_type: 'dog',
            food_type: recipes[0]?.recipeType ?? null,
            dogs: [DogHeroes.serializeDog(dog)],
            recipes: DogHeroes.recipesText(recipes),
            extra_products: extraProducts,
            ...DogHeroes.dogPriceFields(recipes),
          })
        })
      }

      // The chosen extras as text, e.g. "Crunchy Bites Fragola, Ciotola portatile".
      #extraProductsText() {
        return this.variantTargets
          .filter((variant) => parseInt(variant.dataset.quantity) > 0)
          .map((variant) => variant.dataset.productTitle)
          .join(', ')
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes--steps--variants-picker"] && !Shopify.designMode) return;
  try {
    const { Dog } = DogHeroes

  Stimulus.register(
    'variants-picker',
    class extends Stimulus.Controller {
      static targets = [
        'recipe',
        'frozenRecipe',
        'pantryRecipe',
        'price',
        'suggestedRecipes',
        'notSuggestedRecipes',
        'otherRecipes',
        'title',
      ]

      static values = {
        portionsTable: Array,
        blockingHealthProblems: Array,
        discount: Number,
      }

      connect() {
        this.index = parseInt(this.element.dataset.index)
        this.dog = Dog.find(this.index)
        this.calculateRecipeVariantsAndQuantities()
        this.replaceIndex()
        this.replaceDogName()
        this.moveRecipesToCorrectContainers()
      }

      get intervalDays() {
        return DogHeroes.intervalDays || 14
      }

      get variants() {
        return DogHeroes.variants || []
      }

      get allSellingPlanGroupsByProduct() {
        return DogHeroes.allSellingPlanGroupsByProduct || []
      }

      replaceDogName() {
        const nameElements = this.element.querySelectorAll('span[data-dog-name]')
        nameElements.forEach((element) => {
          element.textContent = this.dog.name
        })
      }

      replaceIndex() {
        const labels = this.element.querySelectorAll('[data-replace-for]')
        labels.forEach((label) => {
          const forValue = label.getAttribute('for')
          label.setAttribute('for', forValue.replace('_INDEX_', this.index))
        })

        const ids = this.element.querySelectorAll('[data-replace-id]')
        ids.forEach((input) => {
          const idValue = input.getAttribute('id')
          input.setAttribute('id', idValue.replace('_INDEX_', this.index))
        })
      }

      moveRecipesToCorrectContainers() {
        // "ovino" matches both "sheep" (frozen) and "lamb" (pantry) products.
        const allergyMapping = {
          pollo: ['chicken'],
          manzo: ['beef'],
          pesce: ['fish'],
          tacchino: ['turkey'],
          anatra: ['duck'],
          cervo: ['deer'],
          coniglio: ['rabbit'],
          maiale: ['pork'],
          ovino: ['sheep', 'lamb'],
        }

        const isAllergic = (productTitle) =>
          this.dog.allergies.some((allergy) =>
            (allergyMapping[allergy] || []).some((keyword) => productTitle.toLowerCase().includes(keyword))
          )

        const dogDiseases = this.dog.diseases || []
        const hasBlockingHealthProblem = dogDiseases.some((disease) =>
          this.blockingHealthProblemsValue.includes(disease)
        )

        const suggestedContainer = this.suggestedRecipesTarget.querySelector('.container')
        const notSuggestedContainer = this.notSuggestedRecipesTarget.querySelector('.container')

        this.recipeTargets.forEach((target) => {
          const productTitle = target.dataset.productTitle
          const isSuggested = target.dataset.isSuggested === 'true'

          if (hasBlockingHealthProblem) {
            const clonedTarget = target.cloneNode(true)
            notSuggestedContainer.appendChild(clonedTarget)
            target.remove()
          } else if (isAllergic(productTitle)) {
            const clonedTarget = target.cloneNode(true)
            notSuggestedContainer.appendChild(clonedTarget)
            target.remove()
          } else if (isSuggested) {
            const clonedTarget = target.cloneNode(true)
            suggestedContainer.appendChild(clonedTarget)
            target.remove()
          }
        })
      }

      hideEmptyContainers(recipeType) {
        const hasChildrenOfType = (container, type) => container.querySelector(`[data-recipe-type="${type}"]`) !== null

        const suggestedContainer = this.suggestedRecipesTarget.querySelector('.container')
        const notSuggestedContainer = this.notSuggestedRecipesTarget.querySelector('.container')
        const otherRecipesContainer = this.otherRecipesTarget.querySelector('.container')

        this.suggestedRecipesTarget.style.display = hasChildrenOfType(suggestedContainer, recipeType) ? '' : 'none'

        this.notSuggestedRecipesTarget.style.display = hasChildrenOfType(notSuggestedContainer, recipeType)
          ? ''
          : 'none'

        this.otherRecipesTarget.style.display = hasChildrenOfType(otherRecipesContainer, recipeType) ? '' : 'none'
      }

      preselectSuggestedRecipes(event) {
        let selectedRecipeType = event.detail.selectedType

        if (this.element.style.display !== 'none') {
          this.suggestedRecipesTarget.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
            if (checkbox.closest('[data-recipe-type]').dataset.recipeType !== selectedRecipeType) return

            checkbox.checked = true
            this.toggleRecipeSelection({ target: checkbox })
          })
        }

        this.hideEmptyContainers(selectedRecipeType)
      }

      calculateRecipeVariantsAndQuantities() {
        let calories = this.dog.daily_calories
        let portion = null

        if (calories > 2500) {
          portion = this.portionsTableValue[this.portionsTableValue.length - 1]
        } else {
          portion = this.portionsTableValue.find((entry) => {
            return calories >= entry.minCalories && calories <= entry.maxCalories
          })
        }

        this.recipeTargets.forEach((productTarget) => {
          this.calculateVariantAndQuantity(productTarget, portion)
        })
      }

      calculateVariantAndQuantity(target, portion) {
        const recipeType = target.dataset.recipeType

        const { variantId, quantity, price, sellingPlanId, weightInGrams } = this.getVariantAndQuantity(
          JSON.parse(target.dataset.variantIds),
          portion,
          recipeType
        )

        const checkbox = target.querySelector("input[type='checkbox']")
        checkbox.dataset.variantId = variantId
        checkbox.dataset.variantQuantity = quantity
        checkbox.dataset.variantPrice = price.toFixed(2)
        checkbox.dataset.sellingPlanId = sellingPlanId
        checkbox.dataset.weightInGrams = weightInGrams

        const lineCents = price * quantity
        const dailyCents = lineCents / this.intervalDays
        const discountPercent = this.discountValue || 40
        // Round to the nearest cent (NOT floor) and mirror the exact
        // expression the cart-recap headline uses (cart-recap.liquid
        // updatePrices: `(dailyPrice * (1 - discount / 100)) / 100`), so the
        // per-recipe daily price shown on this card and the recap's daily
        // price are always identical.
        const discountedDaily = (dailyCents * (1 - discountPercent / 100)) / 100

        target.querySelector('[data-variant-original-price-container]').textContent = `€ ${(dailyCents / 100)
          .toFixed(2)
          .replace('.', ',')}`
        target.querySelector('[data-variant-price-container]').textContent = `€ ${discountedDaily
          .toFixed(2)
          .replace('.', ',')}`
      }

      getVariantAndQuantity(variantIds, portion, recipeType) {
        let variantIndex = portion?.portions[recipeType].variantIndex
        let multiplier = portion?.portions[recipeType].multiplier
        let variantId = variantIds[variantIndex]
        let quantity = Math.ceil(multiplier * this.intervalDays)

        const variantInfo = this.variants.find((variant) => variant.variant_id == variantId)

        let sellingPlanGroup = null

        if (recipeType === 'frozen') {
          const allSellingPlanGroups = this.allSellingPlanGroupsByProduct.find(
            (spg) => spg.product_id === variantInfo.product_id
          ).selling_plan_groups

          const sellingPlanGroups = allSellingPlanGroups.filter((spg) =>
            variantInfo.selling_plan_group_ids.includes(spg.id)
          )

          switch (multiplier) {
            case 0.5:
            case 1:
              if (sellingPlanGroups.length == 1) {
                sellingPlanGroup = sellingPlanGroups[0]
              } else {
                sellingPlanGroup = sellingPlanGroups.find((spg) => !spg.name.toLowerCase().includes('x'))
              }
              break
            case 2:
              sellingPlanGroup = sellingPlanGroups.find((spg) => spg.name.toLowerCase().includes('x2'))
              break
            case 3:
              sellingPlanGroup = sellingPlanGroups.find((spg) => spg.name.toLowerCase().includes('x3'))
              break
          }
        } else {
          const sellingPlanGroupsByProduct = this.allSellingPlanGroupsByProduct.find(
            (spg) => spg.product_id === variantInfo.product_id
          ).selling_plan_groups

          const regex = /\((\d+)-(\d+)\)/
          const productsCount = Math.ceil(multiplier * this.intervalDays)

          if (productsCount < 6) {
            sellingPlanGroup = sellingPlanGroupsByProduct[0]
          } else {
            sellingPlanGroup = sellingPlanGroupsByProduct.find((spg) => {
              const match = regex.exec(spg.name)
              if (match) {
                const min = parseInt(match[1])
                const max = parseInt(match[2])
                return productsCount >= min && productsCount <= max
              }
              return false
            })
          }
        }

        const sellingPlan = sellingPlanGroup.selling_plans.find((sp) => sp.name === 'Box di prova')

        return {
          variantId,
          quantity,
          price: sellingPlan.price_adjustments[0].value,
          sellingPlanId: sellingPlan.id,
          weightInGrams: variantInfo.weight_in_grams,
        }
      }

      toggleRecipeSelection(event) {
        const checkbox = event.target

        this.dispatch('recipeToggled', {
          detail: {
            variantId: parseInt(checkbox.dataset.variantId),
            quantity: parseInt(checkbox.dataset.variantQuantity),
            price: parseInt(checkbox.dataset.variantPrice),
            productTitle: checkbox.dataset.productTitle,
            productHandle: checkbox.dataset.productHandle,
            sellingPlanId: checkbox.dataset.sellingPlanId,
            weightInGrams: parseInt(checkbox.dataset.weightInGrams),
            recipeType: checkbox.closest('[data-recipe-type]')?.dataset.recipeType,
            index: this.index,
            selected: checkbox.checked,
          },
        })
      }
    }
  )

  // NOTE: Portions table data is injected from shop.metafields.custom.portions_table
  // via the <script> tag at the top of this snippet. Use Shop#save_portions_table_dump
  // from the Rails console to update it.
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--recipes"] && !Shopify.designMode) return;
  try {
    const { Dog } = DogHeroes

  Stimulus.register(
    'recipes-selector',
    class extends Stimulus.Controller {
      static values = {
        selectedRecipeTypeStorageKey: { type: String, default: 'selectedRecipeType' },
      }

      static targets = [
        'step',
        'singleDogHeader',
        'multipleDogHeader',
        'variantPickerTemplate',
        'variantPicker',
        'cartButton',
        'headerBackButton',
        'headerBackToQuizButton',
        'badgeContainer',
        'badgeContainerTemplate',
        'badgeTemplate',
        'dogTemplate',
        'frozenRecipe',
        'pantryRecipe',
        'totalPrice',
        'pickerTitle',
      ]

      get cart() {
        if (!DogHeroes.savedCart) DogHeroes.savedCart = new DogHeroes.SavedCart(this.dogs)

        return DogHeroes.savedCart
      }

      async connect() {
        this.dogs = Dog.all()

        // NOTE: Keep in sync with MealPlan::PANTRY_MIN_CALORIES in dogheroes-app
        const PANTRY_MIN_CALORIES = 151
        const pantryAvailable = this.dogs.every((dog) => dog.dailyCalories() >= PANTRY_MIN_CALORIES)
        if (!pantryAvailable) {
          const pantryBtn = this.element.querySelector('[data-recipes-selector-type-param="pantry"]')
          if (pantryBtn) {
            pantryBtn.disabled = true
            pantryBtn.style.opacity = '0.4'
            pantryBtn.style.pointerEvents = 'none'
          }
        }

        this.currentStep = 0
        this.selectedDogIndex = 0
        this.selectedRecipeType = 'frozen'

        this.#renderBadges()
        this.#renderSelectedRecipeType()
        this.#renderDogNamePlaceholders()
        this.#renderDogsSelector()
        this.#renderHeader()
        this.#renderVariantPickers()

        this.#renderCurrentStep()

        this.headerBackButtonTarget.style.display = 'none'

        DogHeroes.selectedDogIndex = this.selectedDogIndex
      }

      selectRecipeType(event) {
        let newType = event.params.type

        if (newType !== this.selectedRecipeType) {
          this.cart.clearSubscription(this.selectedDogIndex)
          this.variantPickerTargets[this.selectedDogIndex]
            ?.querySelectorAll("input[type='checkbox']")
            .forEach((checkbox) => (checkbox.checked = false))
        }

        this.selectedRecipeType = newType
        this.#renderSelectedRecipeType()
        this.dispatch('recipeTypeSelected', { detail: { selectedType: this.selectedRecipeType } })
        this.#pushFoodTypeSelectedEvent()
        this.next()
      }

      selectDog(event) {
        let index = parseInt(event.target.dataset.index)

        this.selectedDogIndex = index
        DogHeroes.selectedDogIndex = index

        let headerTitles = this.multipleDogHeaderTarget.querySelectorAll('div[data-index]')
        headerTitles.forEach((el) => el.removeAttribute('data-selected'))
        headerTitles[index].setAttribute('data-selected', 'true')

        if (this.cart.recipeCountFor(index) === 0) {
          this.cartButtonTarget.setAttribute('disabled', 'true')
        }

        this.#displayCorrectVariantPicker(index)
        this.currentStep = 0
        this.#renderCurrentStep()
        this.headerBackButtonTarget.style.display = 'none'
        this.headerBackToQuizButtonTarget.style.display = ''

        this.badgeContainerTargets.forEach((container) => {
          container.style.display = container.dataset.index === String(index) ? 'flex' : 'none'
        })
      }

      next() {
        let fromStep = this.currentStep
        this.currentStep++

        // Leaving the variants picker means recipes are confirmed for the
        // selected dog — one event per dog (multi-dog fires it N times).
        if (fromStep === 1) this.#pushRecipeSelectedEvents()

        if (this.cart.allDogsHaveRecipes) {
          this.multipleDogHeaderTarget.style.display = 'none'
          this.singleDogHeaderTarget.style.display = 'none'
          this.badgeContainerTarget.style.display = 'none'
        }

        if (this.currentStep === 2) {
          this.dispatch('productsSelected', { bubbles: true })
        }

        this.headerBackButtonTarget.style.display = ''
        this.headerBackToQuizButtonTarget.style.display = 'none'
        this.#renderCurrentStep()
      }

      previous() {
        if (this.currentStep === 0) window.location.href = '/pages/quiz'

        this.currentStep--

        if (this.currentStep <= 1) {
          this.#renderHeader()
          this.badgeContainerTargets.forEach((container) => {
            container.style.display = container.dataset.index === String(this.selectedDogIndex) ? 'flex' : 'none'
          })
        }

        if (this.currentStep === 0) {
          this.headerBackButtonTarget.style.display = 'none'
          this.headerBackToQuizButtonTarget.style.display = ''
        }

        this.#renderCurrentStep()
      }

      updateSelectedRecipes(event) {
        let { index, variantId, selected, ...recipeData } = event.detail

        if (selected) {
          this.cart.addRecipe(index, variantId, recipeData)
        } else {
          this.cart.removeRecipe(index, variantId, recipeData)
        }

        this.updateTotalPrice()
        this.dispatch('selectedRecipesUpdated', { detail: { savedCart: this.cart } })
      }

      updateTotalPrice() {
        const discount = Number.parseFloat(this.element.dataset.cartDiscountValue || '40')
        const discountPercentage = Number.isFinite(discount) ? discount : 40
        // "Box di prova" is an ORDER-level automatic discount (a single
        // percentage off the whole subscription subtotal, first payment only),
        // so Shopify computes it once on the subtotal and rounds. Replicate
        // that exactly: summing per-line floors under-counts the discount and
        // drifts a cent or two above the real checkout total.
        const subscriptionSubtotalCents = this.cart.subscriptions.reduce((total, dogSubscriptions) => {
          return (
            total +
            Object.values(dogSubscriptions).reduce((subtotal, { quantity, price }) => subtotal + quantity * price, 0)
          )
        }, 0)
        const discountedSubscriptionsCents =
          subscriptionSubtotalCents - Math.round((subscriptionSubtotalCents * discountPercentage) / 100)
        const oneTimeCents = Math.round(this.cart.oneTimePurchasesTotal * 100)

        this.totalPriceTarget.textContent = `€${((discountedSubscriptionsCents + oneTimeCents) / 100)
          .toFixed(2)
          .replace('.', ',')}`
      }

      seeIngredients(event) {
        this.dispatch('openIngredientsDrawer', { detail: { id: event.params.id.toString() } })
      }

      async proceedToCheckout() {
        this.#pushPreCheckoutCompletedEvent()
        window.location.href = await this.cart.prepareCheckoutUrl(this.dogs)
      }

      #pushFoodTypeSelectedEvent() {
        DogHeroes.pushToDataLayer({
          event: 'food_type_selected',
          quiz_type: 'dog',
          food_type: this.selectedRecipeType,
          dogs: [DogHeroes.serializeDog(this.dogs[this.selectedDogIndex])],
        })
      }

      // One recipe_selected per dog (Fosca's model): flat dog properties, the
      // recipes as text and the per-dog spend. Fired once all dogs have recipes.
      #pushRecipeSelectedEvents() {
        this.dogs.forEach((dog, index) => {
          let subscription = this.cart.subscriptions[index] || {}
          let recipes = Object.values(subscription)
          DogHeroes.pushToDataLayer({
            event: 'recipe_selected',
            quiz_type: 'dog',
            food_type: recipes[0]?.recipeType ?? this.selectedRecipeType,
            dogs: [DogHeroes.serializeDog(dog)],
            recipes: DogHeroes.recipesText(recipes),
            ...DogHeroes.dogPriceFields(recipes),
            ecommerce: DogHeroes.recipeEcommerce(subscription),
          })
        })
      }

      // Lightweight funnel marker before redirecting to checkout: the per-dog
      // detail is already in recipe_selected / extra_selected, so here we only
      // carry the order total (recipes + one-time extras).
      #pushPreCheckoutCompletedEvent() {
        DogHeroes.pushToDataLayer({
          event: 'pre_checkout_completed',
          quiz_type: 'dog',
          currency: 'EUR',
          total_price: this.#round2(this.cart.subscriptionsSubtotal / 100 + this.cart.oneTimePurchasesTotal),
        })
      }

      #round2(value) {
        return Math.round((value + Number.EPSILON) * 100) / 100
      }

      #renderBadges() {
        let { dog_breeds } = DogHeroes.algorithmData

        this.dogs.forEach((dog, index) => {
          let badgeContainer = this.badgeContainerTemplateTarget.cloneNode(true).content.firstElementChild
          this.badgeContainerTemplateTarget.insertAdjacentElement('afterend', badgeContainer)

          badgeContainer.dataset.index = index.toString()
          badgeContainer.style.display = index === 0 ? 'flex' : 'none'

          let { additional_breed, breed, allergies, activity, hunger } = dog
          let formattedData = [
            `${this.#breedName(breed, dog_breeds)} ${
              additional_breed ? `+ ${this.#breedName(additional_breed, dog_breeds)}` : ''
            }`,
            dog.age.inMonths > 14 ? 'Adulto' : 'Cucciolo',
            allergies.length > 0 ? 'Allergie: ' + allergies.join(', ') : 'No allergie',
            `Cane ${activity.replace(/-/g, ' ').replace(/_/g, ' ')}`,
            `Cane ${hunger.replace(/-/g, ' ').replace(/_/g, ' ')}`,
          ]

          formattedData.forEach((data) => {
            let badgeElement = this.badgeTemplateTarget.cloneNode(true).content.firstElementChild
            badgeElement.textContent = data
            badgeContainer.appendChild(badgeElement)
          })
        })
      }

      #renderDogsSelector() {
        if (this.dogs.length <= 1) return

        this.dogs.forEach((dog, index) => {
          let dogElement = this.dogTemplateTarget.cloneNode(true).content.firstElementChild
          dogElement.toggleAttribute('data-selected', index === 0)
          dogElement.textContent = dog.displayName
          dogElement.dataset.index = index.toString()
          this.dogTemplateTarget.parentNode.insertBefore(dogElement, this.dogTemplateTarget)
        })
      }

      #renderVariantPickers() {
        this.dogs.forEach((_, index) => {
          let variantPickerElement = this.variantPickerTemplateTarget.cloneNode(true).content.firstElementChild
          variantPickerElement.dataset.index = index.toString()
          if (index === 0) variantPickerElement.style.display = 'flex'
          this.variantPickerTemplateTarget.parentNode.insertBefore(
            variantPickerElement,
            this.variantPickerTemplateTarget
          )
        })
      }

      #renderHeader() {
        if (this.dogs.length <= 1) {
          this.multipleDogHeaderTarget.style.display = 'none'
          this.singleDogHeaderTarget.style.display = 'block'

          let headerTitles = this.singleDogHeaderTarget.children
          Array.from(headerTitles).forEach((header) => (header.style.display = 'none'))
          headerTitles[this.currentStep].style.display = 'block'
        } else {
          this.singleDogHeaderTarget.style.display = 'none'
          this.multipleDogHeaderTarget.style.display = ''
        }
      }

      #displayCorrectVariantPicker(index) {
        this.variantPickerTargets.forEach((el, elIndex) => {
          el.style.display = elIndex === index ? 'flex' : 'none'
        })
      }

      #renderCurrentStep() {
        this.stepTargets.forEach((step, index) => {
          step.classList.toggle('active', index === this.currentStep)
        })
        window.scrollTo(0, 0)
      }

      #renderSelectedRecipeType() {
        if (this.selectedRecipeType === 'frozen') {
          this.frozenRecipeTargets.forEach((el) => el.classList.remove('hidden'))
          this.pantryRecipeTargets.forEach((el) => el.classList.add('hidden'))
          this.pickerTitleTarget.textContent = 'surgelate'
        } else if (this.selectedRecipeType === 'pantry') {
          this.pantryRecipeTargets.forEach((el) => el.classList.remove('hidden'))
          this.frozenRecipeTargets.forEach((el) => el.classList.add('hidden'))
          this.pickerTitleTarget.textContent = 'da dispensa'
        }
      }

      #renderDogNamePlaceholders() {
        let dogNames = this.dogs
          .map((dog) => dog.name)
          .filter(Boolean)
          .join(', ')
        dogNames = dogNames.replace(/, ([^,]*)$/, ' e $1')

        this.element.querySelectorAll('[data-dog-name]').forEach((el) => {
          el.textContent = dogNames || 'il tuo cane'
        })
      }

      #breedName(handle, dogBreeds) {
        let breed = dogBreeds.find((breed) => breed.handle === handle)
        return breed ? breed.name : handle.replace(/-/g, ' ').replace(/^./, (c) => c.toUpperCase())
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--age-input"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--age-input',
    class extends Stimulus.Controller {
      static targets = [
        'birthdayType',
        'birthday',
        'absoluteSelector',
        'relativeSelector',
        'absolute',
        'relative',
        'relativeAgeYears',
        'relativeAgeMonths',
        'yearSelector',
        'monthSelector',
        'daySelector',
      ]

      connect() {
        this.render()
      }

      age() {
        return DogHeroes.Age.fromString(this.birthdayTarget.value)
      }

      // --- Custom select bridge ---

      selectController(target) {
        return this.application.getControllerForElementAndIdentifier(target, 'dogheroes--ui--select')
      }

      readSelect(target) {
        const hidden = target.querySelector('input[type="hidden"]')
        return hidden ? hidden.value : ''
      }

      writeSelect(target, value) {
        const controller = this.selectController(target)
        if (controller) {
          controller.setValue(value)
          return
        }
        const hidden = target.querySelector('input[type="hidden"]')
        if (hidden) hidden.value = value == null ? '' : String(value)
      }

      writeSelectOptions(target, options) {
        const controller = this.selectController(target)
        if (controller) {
          controller.setOptions(options)
          return
        }
        const list = target.querySelector('[role="listbox"]')
        if (!list) return
        list.innerHTML = options
          .map(
            (o) =>
              `<li class="item" role="option" data-value="${o.value}" data-action="click->dogheroes--ui--select#onItemClick">${o.label}</li>`
          )
          .join('')
      }

      // --- Render ---

      render() {
        let age = this.birthdayTarget.value ? this.age() : null
        let type = this.birthdayTypeTarget.value || 'approximate'

        this.relativeAgeYearsTarget.value = age?.years || ''
        this.relativeAgeMonthsTarget.value = age?.months || ''
        this.writeSelect(this.yearSelectorTarget, age?.year || '')
        this.writeSelect(this.monthSelectorTarget, age?.month || '')

        if (type == 'relative') {
          this.relativeSelectorTarget.checked = true
          this.absoluteSelectorTarget.checked = false
          this.absoluteTarget.style.display = 'none'
          this.relativeTarget.style.display = 'block'
        } else {
          this.relativeSelectorTarget.checked = false
          this.absoluteSelectorTarget.checked = true
          this.absoluteTarget.style.display = 'block'
          this.relativeTarget.style.display = 'none'

          if (type == 'exact') {
            this.daySelectorTarget.style.display = ''
            this.updateDayOptions()
            if (age?.day) this.writeSelect(this.daySelectorTarget, age.day)
          } else if (type == 'approximate') {
            this.daySelectorTarget.style.display = 'none'
          } else {
            throw new Error(`Invalid birthday type: ${type}`)
          }
        }
      }

      updateDayOptions() {
        let age = this.age()
        if (!age) return
        let { year, month } = age
        let daysInMonth = this.getDaysInMonth(month, year)

        const options = []
        for (let value = 1; value <= daysInMonth; value++) {
          options.push({ value, label: String(value) })
        }
        this.writeSelectOptions(this.daySelectorTarget, options)
      }

      setAbsoluteBirthday() {
        let year = this.readSelect(this.yearSelectorTarget)
        let month = this.readSelect(this.monthSelectorTarget)
        let day = this.readSelect(this.daySelectorTarget)

        let age = new DogHeroes.Age(year, month, day)

        if (year || month) {
          let birthday = age.valueOf()
          this.birthdayTarget.value = birthday

          if (day) {
            this.birthdayTypeTarget.value = 'exact'
          } else {
            this.birthdayTypeTarget.value = 'approximate'
          }
        } else {
          this.birthdayTarget.value = ''
          this.birthdayTypeTarget.value = ''
        }

        this.render()
      }

      setRelativeBirthday() {
        const yearsInput = this.relativeAgeYearsTarget
        const monthsInput = this.relativeAgeMonthsTarget

        // Validate and clamp years (0–30)
        const rawYears = parseInt(yearsInput.value)
        if (!isNaN(rawYears)) {
          yearsInput.value = Math.min(Math.max(rawYears, 0), 30)
        } else {
          yearsInput.value = ''
        }

        // Validate and clamp months (0–11)
        const rawMonths = parseInt(monthsInput.value)
        if (!isNaN(rawMonths)) {
          monthsInput.value = Math.min(Math.max(rawMonths, 0), 11)
        } else {
          monthsInput.value = ''
        }

        const years = yearsInput.value
        const months = monthsInput.value
        this.birthdayTarget.value = DogHeroes.Age.fromRelativeAge(years, months).valueOf()

        this.render()
      }

      blockInvalidKeys(event) {
        if (['e', 'E', '+', '-'].includes(event.key)) {
          event.preventDefault()
        }
      }

      showRelative() {
        this.birthdayTypeTarget.value = 'relative'
        this.render()
      }

      showAbsolute() {
        this.birthdayTypeTarget.value = 'approximate'
        this.render()
      }

      toggleDaySelector() {
        if (this.daySelectorTarget.style.display === 'none') {
          this.birthdayTypeTarget.value = 'exact'
        } else {
          this.birthdayTypeTarget.value = 'approximate'
        }
        this.render()
      }

      getDaysInMonth(month, year) {
        let daysPerMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

        if (month === 2) {
          let isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
          return isLeapYear ? 29 : 28
        }

        return daysPerMonth[month - 1]
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--allergy-checkboxes"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--allergy-checkboxes',
    class extends Stimulus.Controller {
      static targets = ['noAllergy', 'allergy']

      disableOthers() {
        if (this.noAllergyTarget.checked) {
          this.allergyTargets.forEach((checkbox) => {
            checkbox.checked = false
          })
        }
      }

      toggle() {
        if (this.allergyTargets.some((checkbox) => checkbox.checked)) {
          this.noAllergyTarget.checked = false
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--flash-message"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--flash-message',
    class extends Stimulus.Controller {
      dismiss() {
        this.element.remove()
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--health-issues"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--health-issues',
    class extends Stimulus.Controller {
      static targets = ['fieldset', 'checkbox', 'yes']

      connect() {
        this.toggle()
      }

      toggle() {
        if (this.yesTarget.checked) {
          this.fieldsetTarget.style.display = 'flex'
        } else {
          this.fieldsetTarget.style.display = 'none'
          this.checkboxTargets.forEach((checkbox) => {
            checkbox.checked = false
          })
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--select-breed"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--select-breed',
    class extends Stimulus.Controller {
      static targets = ['search', 'hidden', 'list']
      static values = {
        isAdditional: {
          type: Boolean,
          default: false,
        },
      }
      static classes = ['selected', 'active']

      connect() {
        this.dogBreedsValue = DogHeroes.algorithmData.dog_breeds
        let savedDogBreedHandle = this.hiddenTarget.value || ''
        if (!savedDogBreedHandle && this.element.dataset.dogIndex) {
          let dog = DogHeroes.Dog.find(this.element.dataset.dogIndex)
          savedDogBreedHandle = (this.isAdditionalValue ? dog?.additional_breed : dog?.breed) || ''
        }
        this.searchTarget.value = this.dogBreedsValue.find((b) => b.handle === savedDogBreedHandle)?.name || ''
        this.breeds = []
        this.filteredBreeds = []
        this.isOpen = false
        this.activeIndex = -1

        this.handleClickOutside = this.handleClickOutside.bind(this)
        document.addEventListener('click', this.handleClickOutside)

        this.fetchBreeds(this.dogBreedsValue)
        this.renderSelectedBreed()
        this.dispatch('connected')
      }

      disconnect() {
        document.removeEventListener('click', this.handleClickOutside)
      }

      // --- Data ---

      fetchBreeds(dog_breeds) {
        const sorted = [...dog_breeds].sort((a, b) => a.name.localeCompare(b.name))
        const meticcioIndex = sorted.findIndex((b) => b.handle === 'meticcio')
        if (meticcioIndex > -1) {
          const [meticcio] = sorted.splice(meticcioIndex, 1)
          sorted.unshift(meticcio)
        }
        this.breeds = sorted
        this.filteredBreeds = [...this.breeds]
      }

      // --- Open / Close ---

      open() {
        if (this.isOpen) return
        this.isOpen = true
        this.listTarget.hidden = false
        this.searchTarget.setAttribute('aria-expanded', 'true')
        if (this.activeIndex > this.filteredBreeds.length - 1) this.activeIndex = 0
      }

      close() {
        if (!this.isOpen) return
        this.isOpen = false
        this.activeIndex = -1
        this.listTarget.hidden = true
        this.searchTarget.setAttribute('aria-expanded', 'false')
        this.searchTarget.removeAttribute('aria-activedescendant')
      }

      // --- Events ---

      onFocus() {
        this.filter()
        this.renderList()
        this.open()
      }

      onBlur() {
        this.close()
      }

      onInput() {
        this.searchTarget.value = this.searchTarget.value.replace(/^ +/, '').replace(/  +/g, ' ').replace(/\./g, '')
        this.clearSelection()
        this.filter()
        this.activeIndex = 0
        this.renderList()
        this.open()
      }

      moveDown() {
        this.moveActive(1)
      }

      moveUp() {
        this.moveActive(-1)
      }

      onKeydown(event) {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault()
            this.moveActive(1)
            break
          case 'ArrowUp':
            event.preventDefault()
            this.moveActive(-1)
            break
          case 'Enter':
            if (this.searchTarget.getAttribute('aria-expanded') === 'true') {
              event.preventDefault()
              event.stopPropagation()
              if (this.activeIndex >= 0 && this.activeIndex < this.filteredBreeds.length) {
                this.select(this.filteredBreeds[this.activeIndex])
                this.close()
              }
            }
            break
          case 'Escape':
            this.close()
            this.searchTarget.blur()
            break
          case ' ':
            if (this.searchTarget.value.endsWith(' ')) {
              event.preventDefault()
            }
            break
          case '.':
            event.preventDefault()
            break
        }
      }

      onClear() {
        this.clearSelection()
        this.searchTarget.value = ''
        this.filter()
        this.renderList()
        this.searchTarget.focus()
      }

      handleClickOutside(event) {
        if (!this.element.contains(event.target)) {
          this.close()
        }
      }

      // --- Filtering ---

      filter() {
        const query = this.searchTarget.value.trim().toLowerCase()

        if (query === '') {
          this.filteredBreeds = [...this.breeds]
        } else {
          this.filteredBreeds = this.breeds.filter((breed) => breed.name.toLowerCase().includes(query))
        }
      }

      // --- Selection ---

      renderSelectedBreed() {
        const selectedHandle = this.hiddenTarget.value
        const selectedBreed = this.breeds.find((b) => b.handle === selectedHandle)
        this.searchTarget.value = selectedBreed ? selectedBreed.name : ''
        if (selectedBreed) {
          this.searchTarget.classList.add(this.selectedClass)
          this.close()
        } else {
          this.searchTarget.classList.remove(this.selectedClass)
        }
      }

      select(breed) {
        this.hiddenTarget.value = breed.handle
        this.renderSelectedBreed()
        this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))

        if (this.isAdditionalValue) {
          const form = this.element.closest('form')
          const nextButton = form?.querySelector('[data-quiz-target="nextButton"]')
          if (nextButton) nextButton.focus()
        }
      }

      clearSelection() {
        this.hiddenTarget.value = ''
        this.searchTarget.classList.remove(this.selectedClass)
      }

      // --- Keyboard navigation ---

      moveActive(direction) {
        if (this.filteredBreeds.length === 0) return

        this.activeIndex += direction

        if (this.activeIndex < 0) this.activeIndex = this.filteredBreeds.length - 1
        if (this.activeIndex >= this.filteredBreeds.length) this.activeIndex = 0

        this.updateActiveOption()
      }

      updateActiveOption() {
        const items = this.listTarget.querySelectorAll("[role='option']:not([aria-disabled])")

        items.forEach((item, index) => {
          if (index === this.activeIndex) {
            item.classList.add(this.activeClass)
            item.scrollIntoView({ block: 'nearest' })
            this.searchTarget.setAttribute('aria-activedescendant', item.id)
          } else {
            item.classList.remove(this.activeClass)
          }
        })
      }

      // --- Rendering ---

      renderList() {
        const listEl = this.listTarget
        listEl.innerHTML = ''

        if (this.filteredBreeds.length === 0) {
          const emptyLi = document.createElement('li')
          emptyLi.classList.add('item', 'item--empty')
          emptyLi.textContent = 'Nessun risultato trovato'
          emptyLi.setAttribute('role', 'option')
          emptyLi.setAttribute('aria-disabled', 'true')
          listEl.appendChild(emptyLi)
          return
        }

        const fragment = document.createDocumentFragment()

        this.filteredBreeds.forEach((breed, index) => {
          const li = document.createElement('li')
          li.id = `breed-option-${breed.handle}`
          li.classList.add('item')
          li.textContent = breed.name
          li.setAttribute('role', 'option')
          li.setAttribute('aria-selected', this.hiddenTarget.value === breed.handle)

          li.addEventListener('mousedown', (e) => e.preventDefault())
          li.addEventListener('click', () => this.select(breed))

          if (index === this.activeIndex) {
            li.classList.add('item--active')
          }

          fragment.appendChild(li)
        })

        listEl.appendChild(fragment)
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--select"] && !Shopify.designMode) return;
  try {
    Stimulus.register(
    'dogheroes--ui--select',
    class extends Stimulus.Controller {
      static targets = ['trigger', 'list', 'hidden']

      connect() {
        this.isOpen = false
        this.activeIndex = -1
        this.handleClickOutside = this.handleClickOutside.bind(this)
        document.addEventListener('click', this.handleClickOutside)
        this.renderTrigger()
        this.renderSelectedState()
      }

      disconnect() {
        document.removeEventListener('click', this.handleClickOutside)
      }

      get value() {
        return this.hiddenTarget.value
      }

      setValue(v) {
        const next = v == null ? '' : String(v)
        if (this.hiddenTarget.value === next) {
          this.renderTrigger()
          this.renderSelectedState()
          return
        }
        this.hiddenTarget.value = next
        this.renderTrigger()
        this.renderSelectedState()
      }

      setOptions(options) {
        const previousValue = this.hiddenTarget.value
        this.listTarget.innerHTML = ''
        const fragment = document.createDocumentFragment()
        options.forEach((opt) => {
          const li = document.createElement('li')
          li.classList.add('item')
          li.setAttribute('role', 'option')
          li.dataset.value = String(opt.value)
          li.textContent = opt.label
          li.dataset.action = 'click->dogheroes--ui--select#onItemClick'
          fragment.appendChild(li)
        })
        this.listTarget.appendChild(fragment)
        if (!this.optionExists(previousValue)) this.hiddenTarget.value = ''
        this.renderTrigger()
        this.renderSelectedState()
      }

      optionExists(value) {
        if (value === '') return true
        return Array.from(this.listTarget.querySelectorAll('[role="option"]')).some(
          (li) => li.dataset.value === String(value)
        )
      }

      onItemClick(event) {
        const li = event.currentTarget
        this.select(li.dataset.value)
      }

      select(value) {
        this.hiddenTarget.value = String(value)
        this.renderTrigger()
        this.renderSelectedState()
        this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }))
        this.close()
        this.triggerTarget.focus()
      }

      toggle(event) {
        event.preventDefault()
        // Safari/Chrome on macOS don't focus <button> on click, which kills
        // keyboard navigation after a mouse-driven open.
        this.triggerTarget.focus()
        this.isOpen ? this.close() : this.open()
      }

      open() {
        if (this.isOpen) return
        this.isOpen = true
        this.listTarget.hidden = false
        this.triggerTarget.setAttribute('aria-expanded', 'true')
        this.element.classList.add(`${this.identifier}--open`)
        this.activeIndex = this.currentIndex()
        this.updateActive()
        this.triggerTarget.focus()
      }

      close() {
        if (!this.isOpen) return
        this.isOpen = false
        this.activeIndex = -1
        this.listTarget.hidden = true
        this.triggerTarget.setAttribute('aria-expanded', 'false')
        this.element.classList.remove(`${this.identifier}--open`)
        this.updateActive()
      }

      handleClickOutside(event) {
        if (!this.element.contains(event.target)) this.close()
      }

      onKeydown(event) {
        const items = this.listTarget.querySelectorAll('[role="option"]')
        if (!this.isOpen) {
          if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
            event.preventDefault()
            event.stopPropagation()
            this.open()
            this.activeIndex = this.currentIndex() < 0 ? 0 : this.currentIndex()
            this.updateActive()
          }
          return
        }
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = items.length === 0 ? -1 : (this.activeIndex + 1) % items.length
            this.updateActive()
            break
          case 'ArrowUp':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = items.length === 0 ? -1 : (this.activeIndex - 1 + items.length) % items.length
            this.updateActive()
            break
          case 'Home':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = 0
            this.updateActive()
            break
          case 'End':
            event.preventDefault()
            event.stopPropagation()
            this.activeIndex = items.length - 1
            this.updateActive()
            break
          case 'Enter':
          case ' ':
            event.preventDefault()
            event.stopPropagation()
            if (this.activeIndex >= 0 && items[this.activeIndex]) {
              this.select(items[this.activeIndex].dataset.value)
            }
            break
          case 'Escape':
            event.preventDefault()
            event.stopPropagation()
            this.close()
            break
          case 'Tab':
            this.close()
            break
        }
      }

      currentIndex() {
        const value = this.hiddenTarget.value
        const items = Array.from(this.listTarget.querySelectorAll('[role="option"]'))
        return items.findIndex((li) => li.dataset.value === value)
      }

      renderTrigger() {
        const placeholder = this.triggerTarget.dataset.selectPlaceholder || ''
        const value = this.hiddenTarget.value
        const items = this.listTarget.querySelectorAll('[role="option"]')
        let label = placeholder
        let hasValue = false
        items.forEach((li) => {
          if (li.dataset.value === value && value !== '') {
            label = li.textContent
            hasValue = true
          }
        })
        this.triggerTarget.textContent = label
        this.triggerTarget.classList.toggle(`${this.identifier}__trigger--placeholder`, !hasValue)
      }

      renderSelectedState() {
        const value = this.hiddenTarget.value
        const items = this.listTarget.querySelectorAll('[role="option"]')
        items.forEach((li) => {
          li.setAttribute('aria-selected', li.dataset.value === value ? 'true' : 'false')
        })
      }

      updateActive() {
        const items = this.listTarget.querySelectorAll('[role="option"]')
        items.forEach((li, i) => {
          if (i === this.activeIndex) {
            li.classList.add('item--active')
            li.scrollIntoView({ block: 'nearest' })
          } else {
            li.classList.remove('item--active')
          }
        })

        // Point the combobox at the highlighted option so screen readers
        // announce it during arrow-key navigation (focus stays on the trigger).
        const active = items[this.activeIndex]
        if (active) {
          if (!active.id) active.id = `${this.listTarget.id}-opt-${this.activeIndex}`
          this.triggerTarget.setAttribute('aria-activedescendant', active.id)
        } else {
          this.triggerTarget.removeAttribute('aria-activedescendant')
        }
      }
    }
  )
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dogheroes--ui--slider-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('range-slider')) {
    class RangeSlider extends HTMLElement {
      connectedCallback() {
        this.object = JSON.parse(this.dataset.object || '{}')
        if (Object.keys(this.object).length === 0) return

        this.numberOfSteps = this.object.steps
        this.total = 100
        this.stepValue = this.total / (this.numberOfSteps - 1)
        this.currentIndexStep = 0

        this.images = this.querySelectorAll('.range-slider-image')
        this.titleText = this.querySelector('[ref="title"]')
        this.descriptionText = this.querySelector('[ref="description"]')
        this.inputQuiz = this.querySelector('[ref="hidden_input"]')

        this.rangeInput = this.querySelector('[ref="input"]')

        this.bindEvents()
        this.selectByHandle() || this.updateFromSliderValue()
      }

      selectByHandle() {
        let selectedHandle = this.dataset.selectedHandle
        if (!selectedHandle) return false

        let index = this.object.items.findIndex((item) => item.handle === selectedHandle)
        if (index === -1) return false

        this.currentIndexStep = index
        this.rangeInput.value = index * this.stepValue
        this.updateUI()
        return true
      }

      bindEvents() {
        this.rangeInput.addEventListener('input', () => this.handleSliderInput())
        this.images.forEach((img, index) => {
          img.addEventListener('click', () => this.handleImageClick(index))
          img.style.cursor = 'pointer'
        })
      }

      handleSliderInput() {
        const sliderValue = parseInt(this.rangeInput.value, 10)
        this.currentIndexStep = Math.round(sliderValue / this.stepValue)
        this.updateUI()
      }

      handleImageClick(index) {
        this.currentIndexStep = index
        this.rangeInput.value = index * this.stepValue
        this.updateUI()
      }

      updateFromSliderValue() {
        const sliderValue = parseInt(this.rangeInput.value, 10)
        this.currentIndexStep = Math.round(sliderValue / this.stepValue)
        this.updateUI()
      }

      updateUI() {
        this.updateImageVisibility()
        this.updateText()
        this.updateInputValue()
      }

      updateImageVisibility() {
        this.images.forEach((img, index) => {
          const isActive = index === this.currentIndexStep
          img.classList.toggle('blurred', !isActive)
          img.classList.toggle('active', isActive)
        })
      }

      updateText() {
        const currentItem = this.object.items[this.currentIndexStep]

        if (this.titleText) this.titleText.textContent = currentItem.label
        if (this.descriptionText) this.descriptionText.textContent = currentItem.description

        // Announce the human-readable option (e.g. "Peso ideale") instead of the
        // raw numeric slider value, which is meaningless on its own.
        if (this.rangeInput) this.rangeInput.setAttribute('aria-valuetext', currentItem.label)
      }

      updateInputValue() {
        const currentItem = this.object.items[this.currentIndexStep]

        if (this.inputQuiz) this.inputQuiz.value = currentItem.handle
      }
    }

    customElements.define('range-slider', RangeSlider)
  }
  } catch(e) { console.error(e); }
})();

})();
